import { render, staticRenderFns } from "./FrameDialogComponent.vue?vue&type=template&id=1ce1c798&scoped=true"
import script from "./FrameDialogComponent.vue?vue&type=script&lang=js"
export * from "./FrameDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce1c798",
  null
  
)

export default component.exports